import { PermissionT } from "../types";

export const visionAdmin = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "vision_admin");
  return !!p;
};

export default visionAdmin;
